module.exports = __webpack_public_path__ + "img/rp-misc-logo.e94a66dd.png";